import { useState, useMemo } from 'react';

interface FilterOptions {
  searchableFields: string[];
  customFilters?: { [key: string]: (item: any) => boolean };
}

export const useTableFilter = <T>(data: T[], options: FilterOptions) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) {
      return data;
    }

    const term = searchTerm.toLowerCase();

    return data.filter(item => {
      // Search in specified fields
      const matchesSearch = options.searchableFields.some(field => {
        const value = (item as any)[field];
        return value && value.toString().toLowerCase().includes(term);
      });

      // Apply custom filters if any
      if (options.customFilters) {
        const customMatch = Object.values(options.customFilters).some(filter => filter(item));
        return matchesSearch || customMatch;
      }

      return matchesSearch;
    });
  }, [data, searchTerm, options]);

  return {
    searchTerm,
    setSearchTerm,
    filteredData,
  };
};
